import { createApp, fetchApps, deleteApp, editApp, installApp } from "../api/api";

export const addApp = (data, navigate) => async (dispatch) => {
    try {
        dispatch({ type:"APP_CREATE_REQUEST" });

        console.log(data);
        const res = await createApp(data);

        if (res.status === 200) {
            dispatch({
                type: 'APP_CREATE_SUCCESS',
                payload: res.data.message
            });
        } else {
            dispatch({
                type: 'APP_CREATE_FAIL',
                payload: res.data
            });
        }

        return res.data;
    } catch (error) {
        console.log(error);
        dispatch({
            type: "APP_CREATE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        })

    }
}

export const getApps = () => async (dispatch) => {
    try {
        const res = await fetchApps();

        console.log(res);
        dispatch({
            type: 'GET_APPS',
            payload: res.data.data
        })

        return res.data.apps;
    } catch (err) {
        console.log(err);
    }
}

export const updateApp = (id, data) => async (dispatch) => {
    try {
        dispatch({ type: "APP_UPDATE_REQUEST" });

        const res = await editApp(id, data);

        dispatch({
            type: 'APP_UPDATE_SUCCESS',
            payload: res.data.assets
        });
        return true;
    } catch (error) {
        dispatch({
            type: "APP_UPDATE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        });
        return false;
    }
}

export const installAppToWorkspace = (id, workspaceId) => async (dispatch) => {
    try {
        dispatch({ type: "APP_UPDATE_REQUEST" });

        const res = await installApp(id, workspaceId);

        dispatch({
            type: 'APP_UPDATE_SUCCESS',
            payload: res.data.assets
        });
        return true;
    } catch (error) {        
        dispatch({
            type: "APP_UPDATE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        });
        return false;
    }
}

export const removeApp = (id) => async (dispatch) => {
    try {
        dispatch({ type: "APP_DELETE_REQUEST" });
        const res = await deleteApp(id);

        dispatch({
            type: 'APP_DELETE_SUCCESS',
            payload: res.data
        });
        return true;
    } catch (error) {
        dispatch({
            type: "APP_DELETE_FAIL",
            payload: error.response?.data?.message || "Something went wrong",
        });
        return false;
    }
} 